<template>
	<div class="o-input" :class="{ 'o-input--invalid': invalidStyle }">
		<textarea
			:id="id"
			:name="id"
			:class="{ filled: modelValue }"
			:value="modelValue"
			:required="required"
			:ref="id"
			v-bind="$attrs"
			@input="$emit('update:modelValue', $event.target.value)"
			@keyup.enter="$emit('keyupenter')"
			@blur="onBlur()"
		/>
		<label :for="id">{{ placeholder }}</label>
		<span class="o-input__error" v-if="invalidStyle">{{
			error ? error : translations['Field is required']
		}}</span>
	</div>
</template>

<script>
export default {
	name: 'FieldArea',
	inheritAttrs: false,
	props: {
		id: String,
		modelValue: {
			type: String,
			default: '',
		},
		schema: {
			type: String,
			default: 'text',
		},
		placeholder: String,
		error: {
			type: String,
			default: '',
		},
		required: {
			type: Boolean,
			default: false,
		},
		doValidate: {
			type: Boolean,
			default: true,
		},
	},
	data: () => {
		return {
			invalidStyle: false,
			isValid: false,
			isInit: true,
		};
	},
	watch: {
		doValidate() {
			this.fieldChanged();
		},
		modelValue() {
			this.fieldChanged();
		},
	},
	methods: {
		onBlur() {
			this.isInit = false;
			this.fieldChanged();
		},

		fieldChanged() {
			if (this.required) {
				// VALUE SET
				if (this.modelValue) {
					// DEFAULT TO FALSE
					this.isValid = false;

					switch (this.schema) {
						// EMAIL
						case 'email':
							if (/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(this.modelValue)) {
								this.isValid = true;
							}
							break;

						default:
							this.isValid = true;
							break;
					}
				}

				// VALUE NOT SET
				else {
					this.isValid = false;
				}

				// Add validation style
				if (this.doValidate && !this.isInit) {
					if (this.isValid) {
						this.invalidStyle = false;
					} else {
						this.invalidStyle = true;
					}
				}

				// Emit validation
				this.$emit('changed', {
					fieldname: this.id,
					isfieldvalid: this.isValid,
				});
			}
		},
	},

	mounted() {
		this.fieldChanged();
	},
};
</script>
